<template>
	<v-flex xs12>
		<v-card>
			<v-card-title>
				<v-flex xs3>
					<v-toolbar-title>Contact Us: Message</v-toolbar-title>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						v-model="search"
						append-icon="search"
						label="Search"
						single-line
						hide-details
					></v-text-field>
				</v-flex>
			</v-card-title>
			<v-data-table
				:headers="headers"
				:items="body"
				:search="search"
				:options.sync="options"
				:server-items-length="total"
				:loading="loading"
				:single-expand="true"
				:sort-by="['createdDate']"
				:sort-desc="[true]"
				show-expand
			>
				<template v-slot:expanded-item="{ headers, item }">
					<td :colspan="headers.length">{{ item.message }}</td>
				</template>
				<template v-slot:no-data>
					<v-alert :value="true">No results found.</v-alert>
				</template>
			</v-data-table>
		</v-card>
	</v-flex>
</template>

<script>
	import commonservice from "../../shared/common.service";
	export default {
		data() {
			return {
				search: "",
				loading: false,
				options: {},
				total: 0,
				headers: [
					{ text: "Name", value: "name" },
					{ text: "Email", value: "email" },
					{ text: "Subject", value: "subject", sortable: false },
					{ text: "Created Date", value: "createdDate" },
				],
				body: [],
			};
		},
		watch: {
			options: {
				handler() {
					this.getData();
				},
				deep: true,
			},
			search() {
				this.getData();
			},
		},
		methods: {
			editItem(item) {
				this.$router.push("/contactus/edit/" + item.id);
			},
			deleteItem(item) {
				var title = "Are you sure, you want to delete feedback?";
				commonservice.showDialog("Delete", title).then((result) => {
					if (result.value) {
						this.$store
							.dispatch("contactus/deleteContactus", { id: item.id })
							.then(() => {
								this.getData();
								commonservice.showSuccessMessage(
									"Contact Us deleted successfully"
								);
							});
					}
				});
			},
			getData() {
				this.$store
					.dispatch("contactus/loadContactus", {
						pagination: this.options,
						search: this.search,
					})
					.then((response) => {
						this.loading = false;
						this.body = response.data.data;
						this.total = response.data.total;
					})
					.catch(() => {
						this.loading = false;
					});
			},
		},
	};
</script>
